import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNoSpecialCharacters]'
})
export class NoSpecialCharactersDirective {
  private regex: RegExp = /^[a-zA-Z0-9\s]*$/;

  constructor(private control: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!this.regex.test(value)) {
      // Remove all special characters
      const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
      this.control.control?.setValue(sanitizedValue);
    }
  }
}
